const B_1 = [
    {
        title: '添加中标公告',
        path: '/bidding/projectflow/dingbiao/zhongbiaogg/jsgc/list'
    }
]
export default {
    path: 'jsgc',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-zhongbiaogg-jsgc'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/jsgc/list'),
            meta: {
                title: '添加中标公告列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/jsgc/form'),
            meta: {
                title: '添加/修改中标公告',
                bread: '/bidding/projectflow/dingbiao/zhongbiaogg/jsgc/form'
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zhongbiaogg/jsgc/detail'),
            meta: {
                title: '查看中标公告',
                bread: '/bidding/projectflow/dingbiao/zhongbiaogg/jsgc/show'
            },
        }        
    ]
}